import React, { useEffect, useState } from 'react'
import QuizQuestionItemView from '../component/QuizQuestionItemView'
import QuizQuestionOption from '../../QuizQuestionOption/QuizQuestionOption'

const QuizQuestionItem = ({
  questionId,
  choices,
  uniqueIds,
  correctAnswerIndexes,
  description,
  type,
  cityId,
  onAddOption,
  onDeleteOption,
  onDeleteQuestion,
  onSetCorrectAnswer,
  onOptionChange,
  onQuestionChange,
  onQuestionTypeChange,
}) => {
  const [options, setOptions] = useState([])
  useEffect(() => {
    const options = (choices || []).map((choice, index) => {
      return (
        <QuizQuestionOption
          key={'Option' + uniqueIds[index]}
          index={index}
          value={choice}
          type={type}
          isCorrectAnswer={correctAnswerIndexes.includes(index)}
          onOptionChange={({ text }) =>
            onOptionChange({ questionId, optionIndex: index, text })
          }
          onDeleteOption={() =>
            onDeleteOption({ questionId, optionIndex: index })
          }
          onChangeCorrectAnswer={() =>
            onSetCorrectAnswer({ questionId, correctAnswerIndex: index })
          }
          onAddOption={() => onAddOption({ questionId })}
        />
      )
    })
    setOptions(options)
  }, [choices, correctAnswerIndexes, type])

  return (
    <QuizQuestionItemView
      description={description}
      type={type}
      cityId={cityId}
      onDeleteQuestion={() => onDeleteQuestion({ questionId })}
      onQuestionChange={value => onQuestionChange({ questionId, value })}
      onAddOption={() => onAddOption({ questionId })}
      onQuestionTypeChange={newType =>
        onQuestionTypeChange({ questionId, newType })
      }
      isDisabled={!questionId.includes('newQuestion')}
    >
      {options}
    </QuizQuestionItemView>
  )
}

export default QuizQuestionItem
